import { render, staticRenderFns } from "./OurCourse.vue?vue&type=template&id=362e78b3&scoped=true&"
import script from "./OurCourse.vue?vue&type=script&lang=js&"
export * from "./OurCourse.vue?vue&type=script&lang=js&"
import style0 from "./OurCourse.vue?vue&type=style&index=0&id=362e78b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362e78b3",
  null
  
)

export default component.exports